import * as React from 'react';
const SvgTrash = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 16 17" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 3.003a3 3 0 013-3h2a3 3 0 013 3h2a1 1 0 110 2h-.654l-.74 9.615a1.5 1.5 0 01-1.495 1.385H4.889a1.5 1.5 0 01-1.496-1.385l-.74-9.615H2a1 1 0 010-2h2zm1.586 2.95a.8.8 0 00-.736.86l.425 5.505a.8.8 0 101.596-.124L6.445 6.69a.8.8 0 00-.86-.736zm3.969.742a.8.8 0 011.595.123l-.425 5.493a.8.8 0 11-1.595-.123l.425-5.493zM7 2.003a1 1 0 00-1 1h4a1 1 0 00-1-1H7z"
            fill="currentColor"
        />
    </svg>
);
export default SvgTrash;
